import React from "react";
import { Box, Typography } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridRowParams,
  GridSortModel,
  GridToolbarQuickFilter,
  GridValidRowModel,
  esES,
} from "@mui/x-data-grid";

interface DataGridProps {
  rows: readonly GridValidRowModel[];
  columns: GridColDef[];
  handleRowDoubleClick?: (params: GridRowParams) => void;
  pageSize?: number;
  search?: boolean;
  columnVisible?: any;
  processRowUpdate?: (newRow: any) => any;
  disablePagination?: boolean;
  footerContent?: React.ReactNode;
  paginationModel?: { page: number; pageSize: number };
  onPaginationModelChange?: (model: { page: number; pageSize: number }) => void;
  paginationMode?: 'client' | 'server';
  sortingMode?: 'client' | 'server';
  sortModel?: GridSortModel;
  onSortModelChange?: (model: GridSortModel) => void;
  rowCount?: number;
  loading?: boolean;
  checkboxSelection?: boolean;
  onRowSelectionModelChange?: (newSelection: any) => void;
  rowSelectionModel?: any;
}

const CustomDataGrid: React.FC<DataGridProps> = ({
  rows,
  columns,
  handleRowDoubleClick,
  search = true,
  pageSize = 10,
  paginationModel,
  onPaginationModelChange,
  paginationMode = 'client',
  sortingMode = 'client',
  sortModel,
  onSortModelChange: onSortModelChange,
  rowCount,
  loading,
  columnVisible,
  processRowUpdate,
  disablePagination = false,
  footerContent,
  checkboxSelection = false,
  onRowSelectionModelChange,
  rowSelectionModel,
}) => {
  function QuickSearchToolbar() {
    return (
      <Box sx={{ p: 2, pb: 0 }}>{search && <GridToolbarQuickFilter />}</Box>
    );
  }

  function NoRowsOverlay() {
    return (
      <Typography
        sx={{
          textAlign: "center",
          p: 3,
          backgroundColor: "#f0f0f0",
          color: "#999",
        }}
        variant="h6"
      >
        No hay datos disponibles
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pagination
        paginationMode={paginationMode}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        sortingMode={sortingMode}
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        rowCount={rowCount}
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize,
              page: paginationModel?.page ?? 0,
            },
          },
        }}
        pageSizeOptions={[pageSize, 25, 100]}
        onRowDoubleClick={handleRowDoubleClick}
        components={{ Toolbar: search ? QuickSearchToolbar : undefined, NoRowsOverlay }}
        localeText={{
          ...esES.components.MuiDataGrid.defaultProps.localeText,
          MuiTablePagination: { labelRowsPerPage: "Elementos por página" },
          footerRowSelected: () => ``,
        }}
        columnVisibilityModel={columnVisible}
        processRowUpdate={processRowUpdate}
        hideFooterPagination={disablePagination}
        checkboxSelection={checkboxSelection}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        sx={{
          '& .MuiDataGrid-columnHeaderCheckbox': {
            paddingLeft: '3px',
          },
        }}
      />

      {footerContent && footerContent}
    </Box>
  );
};

export default CustomDataGrid;
